import Vue from "vue";
import VueEditor from "vue2-editor";
import "quill/dist/quill.core.css";

Vue.use(VueEditor);

export default VueEditor;
